 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		20: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		20: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"4e5074ae33eb935a2236a0c8ece5909605093f7b","1":"65c645571d40f424b8e5cb102aca84c7633c4373","2":"ac42056150a2dd3d9db06e11d62ffda93c769857","3":"c0665d0da16bd5dcd606a1f810a9ec852c78632b","4":"9f3dc49f8fb69d0875dcf360554619cae63a2bdf","5":"1cb29766100500e43652a32d053ea4f00297c263","6":"1bfc9850","7":"36dac2e1e76c4582eacaa0f7eea0dbc95da6e732","8":"ab1977cb9de8b580670ad0e284a5b62d42bcd4fd","9":"604070675efdbf9c16319e1701f1817ab3505696","10":"f194576330eb3f1ec47b44d891f8cf9198bb10ea","11":"61d8cbb03ec7453ccac31ef6ede495e2e456ec77","12":"f732e7ecb57b6f5765f5b2e64864affb3ca63bf4","13":"styles","14":"060d9b80ea08f2cb566c04557fae4bf7a08c7e28","15":"aa86f09b394bcc52b0afcfe9ac3e786c6b02fd43","16":"cc58f269841b92fab4ac231e2c79aaa7ea3efa03","17":"component---src-pages-landing-page-landing-page-jsx","18":"da331763330e341457862941a057632f8501ec57","19":"87c91664d8ccdf725936ad249a30304df61fa0f9","22":"component---node-modules-gatsby-plugin-offline-app-shell-js","23":"component---src-pages-components-components-jsx","24":"component---src-pages-components-sections-product-section-jsx","25":"component---src-pages-components-sections-section-basics-jsx","26":"component---src-pages-components-sections-section-carousel-jsx","27":"component---src-pages-components-sections-section-completed-examples-jsx","28":"component---src-pages-components-sections-section-download-jsx","29":"component---src-pages-components-sections-section-examples-jsx","30":"component---src-pages-components-sections-section-javascript-jsx","31":"component---src-pages-components-sections-section-login-jsx","32":"component---src-pages-components-sections-section-navbars-jsx","33":"component---src-pages-components-sections-section-notifications-jsx","34":"component---src-pages-components-sections-section-pills-jsx","35":"component---src-pages-components-sections-section-tabs-jsx","36":"component---src-pages-components-sections-section-typography-jsx","37":"component---src-pages-contact-js","38":"component---src-pages-gallery-page-gallery-page-jsx","39":"component---src-pages-gallery-page-js","40":"component---src-pages-index-js","41":"component---src-pages-landing-page-sections-product-section-jsx","42":"component---src-pages-landing-page-sections-team-section-jsx","43":"component---src-pages-landing-page-sections-work-section-jsx","44":"component---src-pages-location-js","45":"component---src-pages-login-page-login-page-jsx","46":"component---src-pages-profile-page-profile-page-jsx","47":"component---src-pages-profile-page-sections-section-carousel-jsx","48":"component---src-pages-profile-page-sections-section-pills-jsx","49":"component---src-pages-specifications-js"}[chunkId]||chunkId) + "-" + {"0":"8643b90d8d4e73b52885","1":"e5cbd2039aacec95f79f","2":"57f225b92f2bcc961374","3":"a4c68e461a421a3fe8ba","4":"291ba3a8011e508f412f","5":"6bc620e9194dc80f4bdb","6":"4d5c5a7e081b4a565cc5","7":"259c77787e2ed2e3f0ee","8":"3b76d9f841112f8f9208","9":"f97c9ca897d4cca9cec1","10":"4878d3bbd54e92dfe515","11":"9bd949be0ca9939fda59","12":"25f82dff4aa5a0f8ca6e","13":"83801f3b4dd3459a4027","14":"40a506a4a27b5a9ab067","15":"7555f580bfb313b4da57","16":"2ca03daf54c925380f0e","17":"11e87b3a6a8fe96f5ffb","18":"9448a6657f03b170239a","19":"2aa862c4144ce68cc9af","22":"1b113ce0524077a641d5","23":"4e8f6cdafd105a149d96","24":"cfbd8fdb9808373308e8","25":"f2223bf558a2ea622489","26":"0da645403b5a979a1759","27":"f70333aff11f6a1f6096","28":"93e1a1b71a4b1f791eda","29":"cc86835e8867834022ee","30":"7e8c6ca6907f78cde505","31":"9ae94d6e5f7f4b79c79f","32":"946669b163bce02937b1","33":"121ad30be1a7822ff35c","34":"ca4a7fd27b16131113cc","35":"ebfe84c4b2f29a220005","36":"70a86ec623fb6363c498","37":"9a8a7ddf8dd35714625b","38":"a2801910adb43d9f51a0","39":"ea1c64197c8b5f86b907","40":"1e44f0251419e48f3102","41":"12d305399d2d4809de73","42":"aabf8677fe8c7d26a422","43":"691f425ac2491abe5fbe","44":"24e6ad2c783240596fa5","45":"d81fcc28c0fa5d509b54","46":"8d1cf27b3be5004a9f6c","47":"8bc0abd792a0a7869b06","48":"52a1d90e802d31eb677f","49":"a38e78d39de196049089"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"13":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"4e5074ae33eb935a2236a0c8ece5909605093f7b","1":"65c645571d40f424b8e5cb102aca84c7633c4373","2":"ac42056150a2dd3d9db06e11d62ffda93c769857","3":"c0665d0da16bd5dcd606a1f810a9ec852c78632b","4":"9f3dc49f8fb69d0875dcf360554619cae63a2bdf","5":"1cb29766100500e43652a32d053ea4f00297c263","6":"1bfc9850","7":"36dac2e1e76c4582eacaa0f7eea0dbc95da6e732","8":"ab1977cb9de8b580670ad0e284a5b62d42bcd4fd","9":"604070675efdbf9c16319e1701f1817ab3505696","10":"f194576330eb3f1ec47b44d891f8cf9198bb10ea","11":"61d8cbb03ec7453ccac31ef6ede495e2e456ec77","12":"f732e7ecb57b6f5765f5b2e64864affb3ca63bf4","13":"styles","14":"060d9b80ea08f2cb566c04557fae4bf7a08c7e28","15":"aa86f09b394bcc52b0afcfe9ac3e786c6b02fd43","16":"cc58f269841b92fab4ac231e2c79aaa7ea3efa03","17":"component---src-pages-landing-page-landing-page-jsx","18":"da331763330e341457862941a057632f8501ec57","19":"87c91664d8ccdf725936ad249a30304df61fa0f9","22":"component---node-modules-gatsby-plugin-offline-app-shell-js","23":"component---src-pages-components-components-jsx","24":"component---src-pages-components-sections-product-section-jsx","25":"component---src-pages-components-sections-section-basics-jsx","26":"component---src-pages-components-sections-section-carousel-jsx","27":"component---src-pages-components-sections-section-completed-examples-jsx","28":"component---src-pages-components-sections-section-download-jsx","29":"component---src-pages-components-sections-section-examples-jsx","30":"component---src-pages-components-sections-section-javascript-jsx","31":"component---src-pages-components-sections-section-login-jsx","32":"component---src-pages-components-sections-section-navbars-jsx","33":"component---src-pages-components-sections-section-notifications-jsx","34":"component---src-pages-components-sections-section-pills-jsx","35":"component---src-pages-components-sections-section-tabs-jsx","36":"component---src-pages-components-sections-section-typography-jsx","37":"component---src-pages-contact-js","38":"component---src-pages-gallery-page-gallery-page-jsx","39":"component---src-pages-gallery-page-js","40":"component---src-pages-index-js","41":"component---src-pages-landing-page-sections-product-section-jsx","42":"component---src-pages-landing-page-sections-team-section-jsx","43":"component---src-pages-landing-page-sections-work-section-jsx","44":"component---src-pages-location-js","45":"component---src-pages-login-page-login-page-jsx","46":"component---src-pages-profile-page-profile-page-jsx","47":"component---src-pages-profile-page-sections-section-carousel-jsx","48":"component---src-pages-profile-page-sections-section-pills-jsx","49":"component---src-pages-specifications-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"c2db4b443717d6fa1441","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
